// HL_Challenge.jsx
import React, { useEffect, useState } from "react";
import "./HomeLastSection.css";

function HomeLastSection() {
    const Counter = ({ end, duration }) => {
      const [count, setCount] = useState(0);
    
      useEffect(() => {
        let start = 0;
        // Safety check
        if (duration <= 0) {
          setCount(end);
          return;
        }
        
        // Calculate time per increment
        const incrementTime = (duration * 1000) / end;
        const timer = setInterval(() => {
          start += 1;
          setCount((prev) => prev + 1);
          if (start >= end) clearInterval(timer);
        }, incrementTime);
    
        return () => clearInterval(timer);
      }, [end, duration]);
    
      return <span>{count}</span>;
    };
  return (
    <div className="hl-container-fluid">
      <div className="hl-row hl-pos-rel hl-main-wrapper">

        {/* LEFT */}
        <div className="hl-col-12 hl-col-md-6 hl-bg-left">
          <div className="hl-pad-4">
            <h1 className="hl-text-light hl-fs-12 hl-title">We Take Pride in Our Numbers</h1>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hl-col-12 hl-col-md-6 hl-bg-right">
          <div>
            <p className="hl-text-dark hl-fw-bold hl-desc">
             They represent the collective effort of our dedicated team and the trust of our valued clients.
            </p>
             <div className="hom-last-text-dark" style={{ textAlign: 'center', marginTop: '15px' }}>
                <span className="hom-last-counter-item"><Counter end={4} duration={2} />+ Years</span>
                <span className="hom-last-counter-item">|</span>
                <span className="hom-last-counter-item"><Counter end={45} duration={2} />+ Clients</span>
                <span className="hom-last-counter-item">|</span>
                <span className="hom-last-counter-item"><Counter end={25} duration={2} />+ Brands</span>
            </div>
          </div>
        </div>

        {/* FULL WIDTH OVERLAY SLIDER */}
        <div className="hl-slider-overlay">
          <div className="hl-slider">
            <div className="hl-track">

              {/* Original 6 */}
              <div className="hl-slide">
                <img src="img/moscord1.png"
                alt="Moscord" />
                {/* <h5>No real-time operational visibility</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/lackthorn1.png"
                alt="Lackthorn" />
                {/* <h5>Gate congestion & high truck turnaround time</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/smart1.png"
                alt="Smart Village KADOLI"/>
                {/* <h5>Manual errors in data capture</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/unnati.jpg"
                alt="Unnati Motors"/>
                {/* <h5>Increasing container dwell time</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/smile.jpeg"
                alt="Smile Craft"/>
                {/* <h5>Delayed response to operational risks</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/Grupo1.png"
                alt="Group Murchison"/>
                {/* <h5>Disconnected reporting across departments</h5> */}
              </div>

              {/* Duplicate 6 for seamless loop */}
              <div className="hl-slide">
                <img src="img/wilson1.png"
                alt="Wilson, Sons" />
                {/* <h5>No real-time operational visibility</h5> */}
              </div>
              <div className="hl-slide">
                <img src="img/moscord1.png"
                alt="Moscord" />
                {/* <h5>Gate congestion & high truck turnaround time</h5> */}
              </div>
              <div className="hl-slide">
                <img src="img/lackthorn1.png"
                alt="Lackthorn" />
                {/* <h5>Manual errors in data capture</h5> */}
              </div>
              <div className="hl-slide">
                <img src="img/smart1.png"
                alt="Smart Village KADOLI" />
                {/* <h5>Increasing container dwell time</h5> */}
              </div>
              <div className="hl-slide">
                <img  src="img/unnati.jpg"
                alt="Unnati Motors"/>
                {/* <h5>Delayed response to operational risks</h5> */}
              </div>
              <div className="hl-slide">
                <img src="img/smile.jpeg"
                alt="Smile Craft" />
                {/* <h5>Disconnected reporting across departments</h5> */}
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default HomeLastSection;